"use strict";

exports.__esModule = true;
exports.default = void 0;

const getQueryParamByName = (name, url = window.location.href) => {
  // eslint-disable-next-line
  const param = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(encodeURIComponent(results[2].replace(/\+/g, ' '))).replace(/%20/g, ' ');
};

var _default = getQueryParamByName;
exports.default = _default;